<template>
    <el-drawer title="推送设置" :visible.sync="visible" @close="close" size="1000px" :close-on-press-escape="false"
        :wrapperClosable="false" id="comDrawer" :modal-append-to-body="false">
        <div class="drawerView">
            <div class="drawerViewT">
                <div class="drawerCom">
                    <div class="drawerComL">配置编号:</div>
                    <div class="drawerComR">
                        <el-input v-model="params.templateCode" placeholder="请输配置编号" style="width: 600px"></el-input>
                    </div>
                </div>
                <div class="drawerCom">
                    <div class="drawerComL">配置名称：</div>
                    <div class="drawerComR">
                        <el-input v-model="params.templateName" placeholder="配置名称：" style="width: 600px"></el-input>
                    </div>
                </div>
                <div class="drawerCom">
                    <div class="drawerComL">消息类型：</div>
                    <div class="drawerComR">
                        <div>
                            <el-radio-group v-model="params.enum" @change="changeEnumType">
                                <el-radio :label="0" border>Text</el-radio>
                                <el-radio :label="1" border>Image</el-radio>
                                <el-radio :label="2" border>Voice</el-radio>
                                <el-radio :label="3" border>Video</el-radio>
                                <el-radio :label="4" border>File</el-radio>
                                <br>
                                <el-radio :label="5" border>TextCard</el-radio>
                                <el-radio :label="6" border>Markdown</el-radio>
                                <el-radio :label="7" border>News</el-radio>
                                <el-radio :label="8" border>TemplateCard</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="drawerCom">
                    <div class="drawerComL">内容模板：</div>
                    <div class="drawerComR">
                        <el-tooltip class="item" effect="dark" content="模板参数,例如:age,应填写'${age}'" placement="top">
                            <el-input v-model="params.templateContent" :rows="10" type="textarea" style="width: 600px;"></el-input>
                        </el-tooltip>
                    </div>
                </div>

                <div class="drawerCom">
                    <div class="drawerComL">发送对象：</div>
                    <div class="drawerComR">
                        <div>
                            <el-radio-group v-model="params.receiveType" @change="changeClickConfigType">
                                <el-radio :label="1" border>不指定</el-radio>
                                <el-radio :label="2" border>全部</el-radio>
                                <el-radio :label="3" border>指定角色</el-radio>
                                <el-radio :label="4" border>指定人</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="drawerCom" v-if="params.receiveType == 3">
                    <div class="drawerComL">指定角色：</div>
                    <div class="drawerComR">
                        <div>
                            <el-select v-model="params.toPosition" filterable multiple value-key="_id" placeholder="请选择"
                                class="titleSelect" size="medium" @change="handelSearchClick">
                                <el-option v-for="item in positionList" :key="item._id" :label="item.name"
                                    :value="item.name" />
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="drawerCom" v-if="params.receiveType == 4">
                    <div class="drawerComL">指定人：</div>
                    <div class="drawerComR">
                        <div>
                            <el-select v-model="params.toUser" filterable multiple placeholder="请选择" class="titleSelect"
                                size="medium" value-key="title">
                                <el-option v-for="item in staffList" :key="item.title" :label="item.title" :value="item" />
                            </el-select>
                        </div>
                    </div>
                </div>

                <!-- <div class="drawerCom">
                    <div class="drawerComL">备注：</div>
                    <div class="drawerComR">
                        <el-input type="textarea" :rows="4" v-model="params.remark" placeholder="请输入备注" style="width: 600px"
                            resize="none"></el-input>
                    </div>
                </div> -->

            </div>
            <div class="drawerViewB">
                <div class="btn2" @click="close">取消</div>
                <div class="btn" @click="submit">确定</div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            showText: false,
            visible: true,

            messageRoute: [],
            params: {},
            // id:''
            positionId: '',
            positionList: [],
            staffId: '',
            staffList: [],
            handelList: [],
            Elist: [],
            toUser_list: [],
            toPosition_list: []
        };
    },
    props: {
        id: {
            default: '',
        },
    },
    mounted() {
        // this.getConfigInfo()
        this.getStaffList1()
        this.getPositionData()
        this.visible = true;
        console.log(this.id, 'this.id');
        if (this.$public.isNull(this.id)) {
            this.params = {
                id: '',
                enum: '',
                templateName: "",
                templateContent: "", // 默认内容
                receiveType: "",
                templateCode: "",
                toUser: [],
                toPosition: []
            };
        } else {
            let param = {
                id: this.id
            }
            this.$http.get(process.env.VUE_APP_Url38 + 'api/WorkWX/Template/Detail', param).then(res => {
                if (res.code == 0) {
                    this.params = res.data;
                  
                }
            })

        }

    },
    methods: {
        //获取角色列表
        getPositionData() {
            let params = {
                "keyword": '', //关键字
                "pageIndex": 1,
                "pageSize": 1000,
            }
            this.$http.post(process.env.VUE_APP_Url2 + 'api/dict/StaffType/list', params).then(res => {
                if (res.code == 0) {
                    this.positionList = res.data.data

                }
            })
        },

        // 获取销售人员列表
        getStaffList1() {
            let params={
                type:'qywx'
            }
            this.$http.get(process.env.VUE_APP_Url_baseData + '/api/StaffInfo/simple/list',params).then(res => {
                if (res.code == 0) {
                    res.data.forEach((item) => {
                        if(item.value){
                            // console.log(item.label,'value');
                            const obj = {
                            value: item.value,
                            title: item.label,
                        };
                        this.staffList.push(obj)
                        }
                       
                    });
                    
                }
            })
        },
        handelSearchClick(e) {

        },
        change(e) {
            this.$forceUpdate()
        },
        changeEnumType(e) {
            this.params.enum = e
        },
        changeClickConfigType(e) {
            if (e == 1) {
                this.params.receiveType = 1,
                    this.params.toPosition = []
                this.params.toUser = []

            } else if (e == 2) {
                this.params.toPosition = []
                this.params.toUser = []
            } else if (e == 3) {
                this.params.receiveType = 3
                this.params.toUser = []
            } else if (e == 4) {
                this.params.receiveType = 4
                this.params.toPosition = []


            }
        },

        close() {
            this.$emit("submit", {
                type: "close",
            });
        },
        //提交
        submit() {

            if (this.params.receiveType == 4) {
                for (let i = 0; i < this.params.toUser.length; i++) {
                    this.toUser_list.push(this.params.toUser[i]);
                }
                this.params.toUser = this.toUser_list
            }
            if (this.params.receiveType == 3) {
                for (let i = 0; i < this.params.toPosition.length; i++) {
                    this.toPosition_list.push(
                        this.params.toPosition[i],
                    );
                }
                this.params.toPosition = this.toPosition_list
            }
            if (this.$public.isNull(this.params.templateName)) {
                this.$message({
                    type: "error",
                    message: "配置名称输入有误",
                });
                return;
            }
            if (this.$public.isNull(this.params.templateContent)) {
                this.$message({
                    type: "error",
                    message: "推送内容输入有误",
                });
                return;
            }
            if (this.$public.isNull(this.params.receiveType)) {
                this.$message({
                    type: "error",
                    message: "请选择发送对象",
                });
                return;
            }
            if (this.params.receiveType == 2) {
                if (JSON.stringify(this.params.toPosition) == '{}') {
                    this.$message({
                        type: "error",
                        message: "请选择指定角色",
                    });
                    return;
                }
            } else if (this.params.receiveType == 3) {
                console.log(this.params.toUser, "this.params.staffId选择");
                if (JSON.stringify(this.params.toUser) == '{}') {
                    this.$message({
                        type: "error",
                        message: "请选择指定人",
                    });
                    return;
                }
            }
            let params = this.params;
            if (this.$public.isNull(this.id)) {
                this.$http
                    .post(process.env.VUE_APP_Url38 + "api/WorkWX/Template/Create", params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                type: "success",
                                message: "操作成功",
                            });
                            this.$emit("submit", {
                                type: "success",
                            });
                        }
                    });
            } else {
                this.$http
                    .post(process.env.VUE_APP_Url38 + "api/WorkWX/Template/update", params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                type: "success",
                                message: "操作成功",
                            });
                            this.$emit("submit", {
                                type: "success",
                            });
                        }
                    });
            }

        },
    },
};
</script>

<style scoped lang="scss">
#comDrawer {
    ::v-deep .el-drawer__header {
        padding: 20px;
        margin-bottom: 0;
    }

    ::v-deep .el-drawer__body {
        height: calc(100% - 65px);
        overflow-y: auto;
    }
}

.drawerView {
    height: 100%;
    display: flex;
    flex-direction: column;

    .drawerViewT {
        flex: 1;
        box-sizing: border-box;
        border-top: solid 1px #f2f2f2;
        overflow-y: scroll;

        .drawerCom {
            display: flex;
            margin-top: 32px;

            .drawerComL {
                width: 132px;
                margin-right: 22px;
                font-size: 14px;
                color: #343440;
                text-align: right;
                line-height: 20px;
                margin-top: 12px;
            }

            .drawerComR {
                flex: 1;
                line-height: 40px;

                .drawerSelect {
                    display: flex;

                    .drawerSelectItem {
                        width: 128px;
                        height: 44px;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: #69697b;
                        text-align: center;
                        line-height: 44px;
                        position: relative;
                        background: #fafafd;
                        border-radius: 8px;
                        margin-right: 16px;

                        div:nth-of-type(1) {
                            position: absolute;
                            left: 16px;
                            top: 0;
                            bottom: 0;
                            margin: auto 0;
                            width: 16px;
                            height: 16px;
                            border-radius: 100%;
                            border: solid 1px #b0b0bf;
                        }
                    }

                    .drawerSelectActiveItem {
                        width: 128px;
                        height: 44px;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: #577bff;
                        text-align: center;
                        line-height: 44px;
                        position: relative;
                        background: #fafafd;
                        border-radius: 8px;
                        margin-right: 16px;
                        border: 1px solid #577bff;

                        div:nth-of-type(1) {
                            position: absolute;
                            left: 16px;
                            top: 0;
                            bottom: 0;
                            margin: auto 0;
                            width: 4px;
                            height: 4px;
                            border-radius: 100%;
                            border: solid 6px #577bff;
                        }
                    }
                }
            }
        }
    }

    .drawerViewT::-webkit-scrollbar {
        display: none;
    }

    .drawerViewB {
        height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 20px;
        border-top: solid 1px #f2f2f2;
        box-sizing: border-box;

        .btn {
            width: 98px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            cursor: pointer;
            margin-left: 20px;
        }

        .btn2 {
            width: 98px;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            box-sizing: border-box;
            border: solid 1px #577bff;
            color: #577bff;
        }
    }
}</style>
